<template>
  <div>
    <v-row class="">
      <!--  -->
      <v-col class="mt-5" cols="5" md="4">
        <shipment-tracking-card :shipment_details="shipment_details" :shipment_status_log="shipment_status_log"/>
      </v-col>
      <!--  -->
      <v-col class="secodry-text-2 pt-0" cols="7" md="8">
        <v-row class="">
          <v-col class="secodry-text-2 pt-0 text-right" cols="12" md="12">
            <!-- cancel Shipment Btn -->
            <v-btn
                v-if="[$keys.CONFIRMATION_PENDING,$keys.CONFIRMED,$keys.DROPPED_AT_WAREHOUSE,].includes(shipment_details.shipment_status)"
                small
                text
                @click="confirmCancelShipment"
            >
              <v-icon color="#6D7C8E" small> mdi-window-close</v-icon>
              <span class="secodry-text-2">{{ $lang.CANCEL_ORDER }}</span>
            </v-btn>
            <div style="display: inline-block">
              <ShippingLable :shipment_id_list="JSON.stringify([shipment_details.shipment_id])"
                             btn_type="3"></ShippingLable>
            </div>
            <v-btn small text @click="sharePdf">
              <v-icon color="#6D7C8E" size="14"> mdi-share</v-icon>
              <span class="secodry-text-2">{{ $lang.SHARE }}</span>
            </v-btn>
            <v-btn small text @click="raiseIssue">
              <v-icon color="#6D7C8E" size="14"> mdi-message</v-icon>
              <span class="secodry-text-2">{{ $lang.SUPPORT }}</span>
            </v-btn>
          </v-col>

          <!--  -->
          <v-col class="secodry-text-2 pt-5 mt-1" md="5">
            <shipment-detail-block :shipment_details="shipment_details"/>
          </v-col>
          <!--  -->
          <v-col md="7">
            <div>
              <v-row class="">
                <v-col class="pt-0" md="6">
                  <v-card class="d-flex flex-row py-0" flat>
                    <v-card flat>
                      <img alt="img" class="mt-5" src="@/assets/drawer/shipment-active.svg" width="25px">
                    </v-card>
                    <v-card class="pa-2" flat>
                      <p class="secodry-text-2">{{ $lang.PACKETS }}</p>
                      <p class="sub-title-text">{{ shipment_details.number_of_packets }}</p>
                    </v-card>
                  </v-card>
                </v-col>
                <v-col class="pt-0" md="6">
                  <v-card class="d-flex flex-row  py-0" flat>
                    <v-card flat>
                      <v-btn class="mt-4" color="primary" fab outlined x-small>
                        <v-icon color="primary">mdi-currency-inr</v-icon>
                      </v-btn>
                      <!-- <img src="@/assets/rupee.svg"  alt="img"  width="25px" class="mt-4"> -->
                    </v-card>
                    <v-card class="pa-2" flat>
                      <p class="secodry-text-2">{{ $lang.AMOUNT }}</p>
                      <p class="sub-title-text">{{ shipment_details.shipment_amount }}</p>
                    </v-card>
                  </v-card>
                </v-col>
                <v-col class="pt-2 " md="6">
                  <p>{{ $lang.MODE }}</p>
                  <p class="sub-title-text">{{ shipment_details.payment_mode }}</p>
                </v-col>
                <v-col class="pt-2 " md="6">
                  <p>{{ $lang.DELIVERY_MODE }}</p>
                  <p class="sub-title-text">{{ shipment_details.delivery_mode }}</p>
                </v-col>
                <v-col class="pt-2 " md="12">
                  <div v-if="shipment_details.shipment_image " class="">
                    <img :src="shipment_details.shipment_image" alt="img" class="border-a br-8 " height="250"
                         width="360" @click="$store.dispatch('setImageViewer',true)">
                    <p class="secodry-text-2 fs-6  text-right pr-10">{{ shipment_details.image_time[0] }}</p>
                    <p v-if="shipment_details.image_latitude" class="secodry-text-2 fs-6  text-right pr-10">
                      <a :href="'https://www.google.com/maps/search/?api=1&query='+shipment_details.image_latitude+','+shipment_details.image_longitude"
                         target="_blank">({{ shipment_details.image_latitude }},{{ shipment_details.image_longitude }})
                      </a></p>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--  confirmation Dialog for cancell shipment -->
    <confirm-cancel-dialog :cancelShipment="cancelShipment" :dialog="dialog"/>
    <image-viewer :image_src="shipment_details.shipment_image"/>

  </div>
</template>

<script type="text/javascript">
export default {
  components: {
    ShipmentTrackingCard: () => import('./child/ShipmentTrackingCard.vue'),
    ShipmentDetailBlock: () => import('./child/ShipmentDetailBlock.vue'),
    ConfirmCancelDialog: () => import('./child/ConfirmCancelDialog.vue'),
    ImageViewer: () => import('@/components/common-components/ImageViewer.vue'),
    ShippingLable: () =>
        import("@/components/common-components/ShippingLable.vue"),

    // Map :()=>import('@/components/common-components/Map.vue'),
  },
  data() {
    return {
      shipment_id: "",
      shipment_details: {},
      shipment_status_log: [],

      dialog: {
        shipment_id: "",
        flag: false,
        btn_loading: false,
        msg: "",
      }
    }
  },
  created() {
    /*  show and hide the back btn*/
    this.$store.dispatch('drawer/setActiveTab', 'shipments')
    this.shipment_id = this.decrypt(this.$route.params.shipment_id)
    this.getShipmentDetails()
  },
  methods: {
    /* fetch shipemt details data */
    getShipmentDetails() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      let params = {
        shipment_id: this.shipment_id,
      };

      const successHandler = (response) => {
        console.log(response)
        if (response.data.success) {
          this.shipment_details = response.data.data
          this.shipment_status_log = response.data.data.shipment_status_log.reverse()
        }
      };
      const finallyHandler = () => {
        self.$store.dispatch('setPageLoader', false)
      };

      self.request_GET(self, self.$urls.SHIPMENT_DETAILS, params, successHandler, null, null, finallyHandler)
    },
    confirmCancelShipment() {
      this.dialog.shipment_id = this.shipment_id
      this.dialog.flag = true
    },
    /* print shipment details*/
    printShipmentDetails() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      const reqListener = () => {
        var arrayBuffer = xhr.response;
        var fileURL = URL.createObjectURL(xhr.response);
        this.$store.dispatch('setPageLoader', false)
        window.open(fileURL);
      };
      let url = this.$urls.BASE_URL + "shipment/get-pdf/?shipment_id=" + this.shipment_id + "&user_type=" + this.$store.state.user_type;
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", reqListener);
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.overrideMimeType("application/pdf; charset=x-user-defined");
      xhr.send();
      console.log(xhr)
    },
    /* share shipment details*/
    sharePdf() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      const reqListener = () => {
        var arrayBuffer = xhr.response;
        var fileURL = URL.createObjectURL(xhr.response);
        this.$store.dispatch('setPageLoader', false)
        window.open(fileURL);
      };

      let url = this.$urls.BASE_URL + "shipment/share-pdf/?shipment_id=" + this.shipment_id
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", reqListener);
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.overrideMimeType("application/pdf; charset=x-user-defined");
      xhr.send();
      console.log(xhr)
    },
    /* cancel shipment */
    cancelShipment() {
      const self = this;
      var form = new FormData();
      form.append("shipment_id", self.shipment_id);
      form.append("shipment_status", self.$keys.CANCELLED);
      const successHandler = (response) => {
        self.dialog.flag = false
        self.dialog.btn_loading = false
        self.getShipmentDetails()
      };
      const finallyHandler = () => {
      };
      this.request_POST(self, self.$urls.CHANGE_SHIPMENT_STATUS, form, successHandler, null, null, finallyHandler)
    },
    /* raise an isse ticket */
    raiseIssue() {
      this.$router.push({name: 'raise-an-issue', query: {shipment_id: this.encript(this.shipment_id)}})
    }
  }
}


</script>